/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { RightArrow } from '../assets/svg/ArrowIcon';
import { BalanceIcon } from '../assets/svg/PaymentStatus/StatusIcon';
import VerticalCard from './Cards/VerticalCard';
import HorizontalCard from './Cards/HorizontalCard';
import {
  webFormatCurrency,
  useProductName,
  UserDataType,
  renderDescriptionParagraphs
} from '@rb-serve-app/core';
import { useNavigate } from 'react-router-dom';
import { EventType, useAnalytics } from '../ui/Analytics';
import { useSelector } from 'react-redux';
import { TutorialStep } from './InteractiveTutorial';


type Props = {
  vertical: boolean;
  isLoading: boolean;
  assets: {
    icn_master_card: string;
  };
  contentfulData: any;
  rewardsData: any;
  featureFlaggingData: any;
  setShowFeatureFlagMessage: React.Dispatch<React.SetStateAction<boolean>>;
};

const MasterCard = ({
  vertical = false,
  assets,
  contentfulData,
  rewardsData,
  isLoading,
  featureFlaggingData,
  setShowFeatureFlagMessage,
}: Props) => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const { accountDetails } = useSelector((state: any) => state.user);
  const { rewards: rewardsDataForCard, isFirstLoad } = useSelector(
    (state: any) => state.rewards
  );
  const { productName, cardStructure } = useProductName();
  const lang = localStorage.getItem('language') || 'en-US';
  const productWithCardLast4 = [
    productName,
    accountDetails?.customer?.cardLast4,
  ]
    ?.filter(Boolean)
    ?.join(' ');
  const rewardBalance =
    rewardsDataForCard?.pointsDetailsResponse?.rewardBalance;

  const RewardsDatacomponent = () => {
    return (
      <div className="flex items-start md:items-center justify-center flex-col xl:flex-col lg:flex-row md:flex-row gap-2 sm:gap-6 xl:gap-2 md:gap-2">
        <div
          className={`xl:mt-5 mt-0 flex flex-col justify-center items-center`}
        >
          <div
            className="font-normal  text-[14px] md:text-[20px] lg:text-[20px] xl:text-[20px]"
            aria-label={contentfulData?.rewardsBalanceTitle}
          >
            {contentfulData?.rewardsBalanceTitle}
          </div>
          <div
            className="xl:text-[20px] text-[20px] sm:text[22px] font-[650]"
            aria-label={
              rewardsDataForCard?.pointsDetailsResponse?.rewardBalance
            }
          >
            {(() => {
              return rewardBalance === null || rewardBalance === undefined
                ? lang?.includes('en')
                  ? '$-.--'
                  : '-.--$'
                : Number(rewardBalance) < 0
                  ? `-${webFormatCurrency(Math.abs(Number(rewardBalance)), lang)}`
                  : webFormatCurrency(Number(rewardBalance), lang) || '--';
            })()}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`bg-white rounded-[15px] shadow-digital-card flex flex-col justify-center xl:justify-start lg:justify-start
      xl:h-auto xl:pb-2 ${vertical ? 'xl:min-h-[667px]' : 'xl:min-h-[500px]'} lg:min-h[428px] lg:h-auto md:min-h[428px] ipad-portrait:h-auto sm:py-0 ${lang === 'fr' ? 'xl:w-[378px]' : 'xl:w-[380px]'}`}
      aria-labelledby="mastercard-title"
    >
      <div
        id="mastercard-title"
        className={`text-[1.25rem] text-center xl:text-center xl:w-[100%] w-[100%] md:w-[50%] lg:w-[50%]  font-[400] 
          ${
            vertical ? 'xl:mt-[20px] mt-[20px]' : ''
          } xl:mt-[40px] mt-[30px] md:hidden lg:block xl:block pl-5 pr-5 sm:block sm:pl-4 sm:pr-4 text-black`}
      >
       
        {accountDetails?.customer?.cardLast4 && (
          <span
            aria-label={renderDescriptionParagraphs(
              productWithCardLast4,
              ' ',
              true
            )}
          >
            {renderDescriptionParagraphs(productWithCardLast4, ' ')}
          </span>
        )}
      </div>

      <div
        className={`main-card xl:mt-[30px] lg:my-0 md:my-0 mt-[20px] xl:py-0 md:pt-[4%] md:pb-[3%] lg:pt-[4%] lg:pb-[3%] grid xl:grid-cols-1 lg:grid-cols-2 md:grid-cols-2  lg:gap-4 md:gap-4 xl:gap-0 sm:gap-0`}
      >
        <span className="card-container flex justify-center md:items-center lg:items-center">
          <div
            className={`flex flex-col md:gap-0 md:items-center gap-5 justify-center items-center ${vertical ? 'flex-row-reverse' : 'flex-col'}`}
          >
            <span className="text-[1.25rem] text-center font-[400] md:block lg:hidden sm:hidden mb-3 ml-3 hidden text-black">
             
              {accountDetails?.customer?.cardLast4 && (
                <span
                  aria-label={renderDescriptionParagraphs(
                    productWithCardLast4,
                    ' ',
                    true
                  )}
                >
                  {' '}
                  {renderDescriptionParagraphs(productWithCardLast4, ' ')}
                </span>
              )}
            </span>
            {vertical ? (
              <VerticalCard assets={assets} contentfulData={contentfulData} />
            ) : (
              <HorizontalCard assets={assets} contentfulData={contentfulData} />
            )}
            <div className="md:block lg:block xl:hidden sm:block md:mt-6 lg:mt-4 ">
              <RewardsDatacomponent />
            </div>
          </div>
        </span>

        <div>
          <div
            aria-label={renderDescriptionParagraphs(
                    productWithCardLast4,
                    ' ',
                    true
                  )}
            className="text-[17px] text-center font-[400] md:mt-0 lg:mt-0 mb-4 mt-4 xl:hidden hidden sm:hidden md:hidden md:text-left xl:text-center text-black"
          >
           
            {renderDescriptionParagraphs(productWithCardLast4, ' ')}
          </div>
          <div className="hidden md:hidden xl:block sm:hidden lg:hidden">
            <RewardsDatacomponent />
          </div>

          <div
            className={`flex self-center justify-center xl:items-start xl:justify-center  sm:justify-center sm:items-center md:items-start md:justify-start md:w-[100%] lg:items-start lg:justify-start lg:w-[100%] ${vertical ? 'xl:mt-[30px] mt-[20px] lg:mt-0 md:mt-0' : 'xl:mt-[30px] mt-[20px] lg:mt-0 md:mt-0 sm:mt-0'}`}
          >
            <TutorialStep id="redeem-rewards-button">
              <button
                className={`${featureFlaggingData ? 'bg-[#DA291C] text-white' : 'text-gray-400 bg-gray-100 border-gray-300 border-2'} sm:w-[210px] sm:max-w-[210px] md:w-[206px] md:max-w-[206px] h-[48px] px-4 py-2 flex items-center justify-center`}
                aria-label={rewardsData?.redeemRewardsCta}
                onClick={() => {
                  trackEvent(
                    EventType.CLICK_EVENT,
                    'dashboard',
                    window.location.href,
                    'dashboard|reedem rewards'
                  );
                  if (window.scrollY !== 0) {
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }
                  navigate('/redeem-rewards');
                }}
              >
                <span className="text-[16px] font-[650]">
                  {rewardsData?.redeemRewardsCta}
                </span>{' '}
                <span className="mt-1 ml-2">
                  <RightArrow fill={'#fff'} />
                </span>
              </button>
            </TutorialStep>
          </div>

          <div className="px-10 xl:mt-[36px] md:mt-[38px] md:text-left md:p-0 lg:mt-4 lg:text-left lg:p-0 p-5 bg-[#FAFAFA] rounded-[10px] xl:pt-5 xl:px-5">
            <div className="bg-[#FAFAFA] ipad-portrait:p-0 p-5 rounded-[10px]">
              <div
                className="text-[17px] font-[600] font-[#1F1F1F] mb-4"
                id="credit-limit"
                aria-label={`${rewardsData?.creditLimitTitle} ${accountDetails?.creditLimit?.value}`}
              >
                {rewardsData?.creditLimitTitle} :
                {Number(accountDetails?.creditLimit?.value) < 0
                  ? ` -${webFormatCurrency(Math.abs(Number(accountDetails?.creditLimit?.value)), lang)}`
                  : ` ${webFormatCurrency(Number(accountDetails?.creditLimit?.value), lang)}`}
              </div>

              <div className="w-full">
                <div className="flex flex-col lg:flex-row md:flex-col md:gap-2">
                  <div className="md:pr-[0.8rem] flex-1 mb-4 md:mb-0">
                    <div className="flex items-center">
                      <span
                        className="mr-2 md:text-[15px] text-[16px] font-[400] text-gray-500"
                        aria-label={rewardsData?.currentBalanceTitle}
                      >
                        {rewardsData?.currentBalanceTitle}
                      </span>
                      <div className="relative group">
                        <span
                          aria-label="balanceIcon"
                          className="flex items-center mt-1"
                          onClick={() => {
                            trackEvent(
                              EventType.CLICK_EVENT,
                              'dashboard',
                              window.location.href,
                              'dashboard|current balance|tooltip'
                            );
                          }}
                        >
                          <BalanceIcon fill={'#DA291C'} />
                        </span>
                        <div
                          aria-label={renderDescriptionParagraphs(rewardsData?.currentBalanceInfoTip, ' ' , true)}
                          className="max-w-[150px] absolute bottom-full mb-1 hidden group-hover:block bg-gray-50 text-black text-xs rounded px-2 py-1 border border-gray-400 w-max font-[400]"
                        >
                          {renderDescriptionParagraphs(rewardsData?.currentBalanceInfoTip, ' ')}
                        </div>
                      </div>
                    </div>
                    <div className="flex-1 xl:mt-2 mt-4 sm:mt-0">
                      <div
                        className="text-xl font-[650] text-[22px] text-[#1F1F1F]"
                        aria-label={accountDetails?.currentBalance?.value}
                      >
                        {!accountDetails?.currentBalance?.value
                          ? webFormatCurrency(0.0, lang)
                          : Number(accountDetails?.currentBalance?.value) < 0
                            ? `-${webFormatCurrency(Math.abs(Number(accountDetails?.currentBalance?.value)), lang)}`
                            : `${webFormatCurrency(Number(accountDetails?.currentBalance?.value), lang)}`}
                      </div>
                    </div>
                  </div>

                  <div className="md:pl-0 flex-1">
                    <div className="flex items-center">
                      <span
                        className="mr-2 text-gray-500 md:text-[15px] text-[16px] font-[400]"
                        aria-label={rewardsData?.availableCreditTitle}
                      >
                        {rewardsData?.availableCreditTitle}
                      </span>
                      <div className="relative group">
                        <span
                          aria-label="balanceIcon"
                          className="mt-1"
                          onClick={() => {
                            trackEvent(
                              EventType.CLICK_EVENT,
                              'dashboard',
                              window.location.href,
                              'dashboard|available credit|tooltip'
                            );
                          }}
                        >
                          <BalanceIcon
                            aria-label="Available credit icon"
                            fill={'#DA291C'}
                          />
                        </span>
                        <div
                          aria-label={renderDescriptionParagraphs(rewardsData.availableCreditInfoTip, ' ', true)}
                          className="max-w-[150px] absolute bottom-full mb-1 hidden group-hover:block bg-gray-100 text-black text-xs rounded px-2 py-1 border border-gray-400 w-max font-[400] z-[999]"
                        >
                          {renderDescriptionParagraphs(rewardsData.availableCreditInfoTip, ' ')}
                        </div>
                      </div>
                    </div>
                    <div className="flex-1 xl:mt-2 mt-4 sm:mt-0">
                      <div
                        className="text-xl font-[650] text-[22px] text-[#1F1F1F]"
                        aria-label={accountDetails?.realtimeBalance?.value}
                      >
                        {Number(accountDetails?.realtimeBalance?.value) < 0
                          ? `-${webFormatCurrency(Math.abs(Number(accountDetails?.realtimeBalance?.value)), lang)}`
                          : `${webFormatCurrency(Number(accountDetails?.realtimeBalance?.value), lang)}`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-[18px] text-left cursor-pointer">
                <div
                  aria-label={rewardsData?.viewAccountDetailsCtaTitle}
                  className="flex group h-[35px] items-center"
                  onClick={() => {
                    trackEvent(
                      EventType.CLICK_EVENT,
                      'dashboard',
                      window.location.href,
                      'dashboard|view account details'
                    );
                    navigate('/account-details');
                  }}
                >
                  <p className="text-primary-red font-[650] text-[16px] py-3">
                    {rewardsData?.viewAccountDetailsCtaTitle}
                  </p>
                  <span className="hidden group-hover:block ml-2 w-200px transition-opacity duration-2000 ease-in-out">
                    <RightArrow fill={'#DA291C'} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MasterCard);
